(function () {
  function setupHero(hero) {
    if (!hero || hero.dataset.kartologHeroReady === 'true') return;
    hero.dataset.kartologHeroReady = 'true';

    const slides = Array.from(hero.querySelectorAll('.kartolog-hero__slide'));
    const dots = Array.from(hero.querySelectorAll('.kartolog-hero__dot'));
    const previous = hero.querySelector('[data-kartolog-hero-prev]');
    const next = hero.querySelector('[data-kartolog-hero-next]');
    if (slides.length < 2) return;

    let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;

    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === active;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === active);
        dot.setAttribute('aria-current', dotIndex === active ? 'true' : 'false');
      });
    }

    function start() {
      window.clearInterval(timer);
      timer = window.setInterval(() => show(active + 1), 6500);
    }

    previous?.addEventListener('click', () => {
      show(active - 1);
      start();
    });

    next?.addEventListener('click', () => {
      show(active + 1);
      start();
    });

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        show(index);
        start();
      });
    });

    hero.addEventListener('mouseenter', () => window.clearInterval(timer));
    hero.addEventListener('mouseleave', start);

    show(active);
    start();
  }

  function setup() {
    document.querySelectorAll('[data-kartolog-hero]').forEach(setupHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
